// Let Google Maps commit the overlays before dismissing the map loader.
export const afterMapPaint = () => new Promise<void>(resolve => {
  window.requestAnimationFrame(() => window.requestAnimationFrame(() => resolve()));
});
